import { ArrowLeftIcon } from '../../';
import { Hidden, SwipeableDrawer, isWidthDown, makeStyles } from '@material-ui/core';
import { SidebarContext } from './SidebarContext';
import { useHeaderHeight } from '../header';
import { useWidth } from '../UseWidth';
import React, { Fragment, useCallback, useEffect, useMemo, useState } from 'react';
export const sidebarWidth = 400;
const useStyles = makeStyles(theme => ({
    wrapper: {
        flexBasis: sidebarWidth,
        flexGrow: 0,
        flexShrink: 0,
        maxWidth: `calc(100vw - ${theme.spacing(7)}px)`,
        background: '#F8FAFB',
    },
    withPadding: {
        marginTop: theme.spacing(6),
    },
    mainContent: {
        display: 'flex',
        flex: 1,
        // Why? This overrides the automatic minimum size of flex items to pevent child overflow
        // https://stackoverflow.com/questions/43809612/prevent-a-child-element-from-overflowing-its-parent-in-flexbox
        minWidth: 0,
        flexDirection: 'column',
        background: '#ffffff',
        position: 'relative',
    },
    paperProps: {
        width: sidebarWidth,
        maxWidth: `calc(100vw - ${theme.spacing(7)}px)`,
    },
    innerWrapperDesktop: {
        width: sidebarWidth,
        borderLeft: `1px solid ${theme.palette.divider}`,
        position: 'fixed',
        overflowY: 'auto',
        overflow: '-moz-scrollbars-none',
        '-ms-overflow-style': 'none',
        maxHeight: '100%',
        '&::-webkit-scrollbar': {
            width: '0 !important',
        },
        '& > *:first-child': {
            borderTop: 'none',
        },
        '& > *': {
            borderRight: 'none',
        },
    },
    showSidemenuButton: {
        position: 'fixed',
        right: 0,
        top: '30%',
        backgroundColor: 'white',
        borderTopLeftRadius: 100,
        borderBottomLeftRadius: 100,
        transition: 'all 0.3s ease',
        padding: 4,
        paddingRight: 20,
        cursor: 'pointer',
        marginRight: -10,
        fontSize: 24,
        border: '1px solid #e9ecef',
        boxShadow: '0 1px 2px #00000014',
        '&:hover': {
            marginRight: -8,
        },
    },
}));
const _SidebarProvider = ({ children }) => {
    const [elementHistory, setElementHistory] = useState([]);
    const width = useWidth();
    const [isVisible, setVisible] = useState(isWidthDown(width, 'lg'));
    const [wasBig, setBig] = useState(isWidthDown(width, 'lg'));
    const classes = useStyles();
    const isBig = isWidthDown(width, 'lg');
    const revertComponent = useCallback(() => {
        return setElementHistory(history => history.slice(0, -1));
    }, []);
    const replaceComponent = useCallback((newNode) => setElementHistory(history => {
        if (history.length < 2) {
            return [...history, newNode];
        }
        return [...history.slice(0, -1), newNode];
    }), []);
    const showSidebar = useCallback(() => setVisible(true), []);
    const hideSidebar = useCallback(() => setVisible(false), []);
    const contextValue = useMemo(() => ({ showSidebar, hideSidebar, replaceComponent, isVisible, revertComponent }), [
        hideSidebar,
        showSidebar,
        replaceComponent,
        revertComponent,
        isVisible,
    ]);
    const headerHeight = useHeaderHeight();
    useEffect(() => {
        if (isBig !== wasBig) {
            setVisible(!wasBig);
            setBig(isBig);
        }
    }, [isBig, wasBig]);
    const element = elementHistory[elementHistory.length - 1];
    return (React.createElement(SidebarContext.Provider, { value: contextValue },
        React.createElement("div", { style: { display: 'flex', flexGrow: 1 } },
            React.createElement("div", { className: classes.mainContent }, children),
            element && (React.createElement(Fragment, null,
                React.createElement(Hidden, { mdDown: true }, isVisible && (React.createElement("div", { className: classes.wrapper },
                    React.createElement("div", { className: classes.innerWrapperDesktop, style: { height: `calc(100vh - ${headerHeight}px)` } }, element)))),
                React.createElement(Hidden, { lgUp: true },
                    !isVisible && (React.createElement("div", { className: classes.showSidemenuButton, onClick: () => setVisible(true) },
                        React.createElement(ArrowLeftIcon, null))),
                    React.createElement(SwipeableDrawer, { anchor: "right", open: isVisible, onOpen: () => setVisible(true), onClose: () => setVisible(false), PaperProps: { classes: { root: classes.paperProps } } },
                        React.createElement("div", { className: classes.wrapper, role: "presentation" }, element))))))));
};
export const SidebarProvider = _SidebarProvider;
//# sourceMappingURL=SidebarProvider.js.map